import type { FaireProductEntity } from "../../entity_types/product";

export const p_zp787c5sfh: FaireProductEntity = {
  token: "p_zp787c5sfh",
  type: "product",
  name: "Gold Bezel Necklace Charm Jewelry Sets - Waterproof - NG035",
  brandToken: "b_dmzj4e52w6",
  brandName: "AAJewelry",
  imageUrl: "https://cdn.faire.com/fastly/c285072dd97b2407558a41d2696deb6ee8a37dd6be58bfb1f174a4798c394bc0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb786c51d3f65a1bb308920e5140d0613eea1db8e6ae54f3778f5d602f27944b.jpeg",
    "https://cdn.faire.com/fastly/c66d9be0f56e7d36cb9a8bdd17c44b5a345041caf5c2f138959727aa864b80ad.jpeg",
    "https://cdn.faire.com/fastly/414350d5d40f108621eeb95dd7118e2c5070543e9e6c4c44116f36de53407641.jpeg",
    "https://cdn.faire.com/fastly/a0560f10d594adf9457749003c89edfe207a3f0e04f8b5e3f9a7f049f6197b83.jpeg",
    "https://cdn.faire.com/fastly/ba5af2dc9b2901f3da5db168944618bdda700ec4d990c86cc0831b3df83d6483.jpeg",
    "https://cdn.faire.com/fastly/20d77e95ff83fcaae6df18cd534324a9e3a96779c638a99a716525567ba57db6.jpeg",
    "https://cdn.faire.com/fastly/28bb9581f33e58cf83e596fbcbc2def79c5a0af88870b55e267cf6e3048a40f9.jpeg"
  ],
  priceDollars: 20.79,
  description: "A timeless matching set featuring a dainty gold bezel CZ necklace and coordinating stud earrings. Clean, minimal, and easy to wear every day — perfect for layering or wearing as a complete look. A versatile jewelry set that makes a beautiful, ready-to-gift piece.\n\nPRODUCT QUALITY\nExpertly handcrafted from sterling silver and stainless steel, our jewelry features thick gold and rhodium plating for lasting shine. Finished with durable 18k PVD coating adding extra layers of genuine gold, each piece stays brilliant and resists daily wear for years to come.\n\nDETAILS\n▪ Necklace Length: 16\" + 2\" Ext   \n▪ Earring/Pendant: Width: 7.2mm + Height: 3mm\n• 5A High Quality Cubic Zirconia Diamond: 3mm \n▪ Thick 18k gold plated - Sterling Silver \n▪ Hypoallergenic ▪ Nickel-free ▪ Non tarnish ▪ Water Resistant",
  tags: [],
  msrpDollars: 83.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:00.691Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
